import React from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const PersonIcon = () => (
  <Icon tooltip="Person" iconObj={faUser} />
);

export default PersonIcon;